<template>
  <router-link
    class="CategoryCard"
    :class="[
      ('bg-' + color + '-gradient'),
    ]"
    :to="to">
    <h3
      class="CategoryCard_title">
      {{ title }}
    </h3>
    <p
      class="CategoryCard_overview">
      {{ overview }}
    </p>
  </router-link>
</template>

<script>
export default {
  name: 'CategoryCard',

  props: {
    title:    { type: String, default: 'Title' },
    overview: { type: String, default: 'Overview' },
    color:    { type: String, default: 'purple' },
    to:       { type: [String, Object], default: '/' },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.CategoryCard {
  display: block;
  padding: 20px 24px;
  font-size: 12px;
  color: $white;
  background-color: $white;
  border-radius: 2px;
  box-shadow: 0 2px 8px 0 rgba($black, .1);
  cursor: pointer;
  &:hover {
    box-shadow: 0 2px 8px 4px rgba($black, .1);
  }
}

.CategoryCard_title,
.CategoryCard_overview {
  text-shadow: rgba(0, 0, 0, 0.2) 0px 1px 1px;
}

.CategoryCard_overview {
  margin-top: 8px;
}
</style>
